import React from 'react';
import { ExternalLink, Compass, BarChart3, Brain, Home, Music, Calendar, User } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const platforms = [
  {
    name: 'Stevenyong.live',
    url: 'https://stevenyong.live',
    description: 'The official platform of Steven Yong — Chinese Metaphysics consultant, educator, and founder of the Life Decoder ecosystem.',
    icon: User,
    color: '#C89B3C',
  },
  {
    name: 'Bazi.live',
    url: 'https://bazi.live',
    description: 'A modern BaZi (Four Pillars of Destiny) analysis platform. Plot your destiny chart, explore Luck Pillars, and discover your personality profiles.',
    icon: Compass,
    color: '#E85D47',
  },
  {
    name: 'QMDJ.live',
    url: 'https://qmdj.live',
    description: 'Qi Men Dun Jia plotter for strategic forecasting. Access ancient divination tools for decision-making, timing, and directional analysis.',
    icon: BarChart3,
    color: '#4A90D9',
  },
  {
    name: 'Fengshuiplotter.live',
    url: 'https://fengshuiplotter.live',
    description: 'Transform your floor plan into a Feng Shui map in seconds. Align the 24 Mountains, find your home\'s center point, and reveal directional energy using the Luo Pan system.',
    icon: Home,
    color: '#5B8C6B',
  },
  {
    name: 'Lifecode.live',
    url: 'https://lifecode.live',
    description: 'Unlock your personal numerology profile. Discover your Life Path number, Expression number, Soul Urge, and core numbers that shape your destiny.',
    icon: Brain,
    color: '#9C27B0',
  },
  {
    name: 'Lifetunes.live',
    url: 'https://lifetunes.live',
    description: 'Sound healing and vibrational frequency tools aligned with Chinese metaphysics. Tune into the energy frequencies that resonate with your personal chart.',
    icon: Music,
    color: '#FF9800',
  },
  {
    name: 'Onlinetongshu.com',
    url: 'https://onlinetongshu.com',
    description: 'The modern Chinese Tong Shu (Almanac) platform. Check daily auspicious activities, monthly energy charts, and color-coded calendars for strategic planning.',
    icon: Calendar,
    color: '#00BCD4',
  },
];

const ResourcesPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 pt-20" data-testid="resources-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-amber-400 text-sm font-medium tracking-widest uppercase mb-4">Our Ecosystem</p>
          <h1 className="text-4xl md:text-5xl font-light text-white mb-4">
            Life Decoder <span className="font-serif italic text-amber-200">Platforms</span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            A suite of modern tools built to make Chinese metaphysics accessible, practical, and powerful for everyday life.
          </p>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {platforms.map((platform) => (
            <a
              key={platform.name}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group"
              data-testid={`resource-${platform.name.toLowerCase().replace(/\./g, '-')}`}
            >
              <Card className="bg-gray-900/50 border-gray-800 hover:border-gray-600 transition-all duration-300 h-full group-hover:-translate-y-1">
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div
                      className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
                      style={{ background: `${platform.color}15` }}
                    >
                      <platform.icon className="w-6 h-6" style={{ color: platform.color }} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-2">
                        <h3 className="text-white font-semibold text-lg group-hover:text-amber-200 transition-colors">
                          {platform.name}
                        </h3>
                        <ExternalLink className="w-4 h-4 text-gray-600 group-hover:text-amber-400 transition-colors" />
                      </div>
                      <p className="text-gray-400 text-sm leading-relaxed">
                        {platform.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ResourcesPage;
